<app-fire-foresight-menu></app-fire-foresight-menu>

<!-- BEGIN #content -->
<div id="content" class="app-content">

<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a [routerLink]="['/home']">Home</a>
      </li>
      <li class="breadcrumb-item">
        <a>Fire Foresight</a>
      </li>
      <li class="breadcrumb-item">
        <a>Incidents</a>
      </li>
      <li class="breadcrumb-item" *ngIf="status">
        <a>{{status.displayName}}</a>
      </li>
    </ol>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">

  <div class="modal fade" bsModal #falsePositiveModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">False Positive</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="falsePositiveModal.hide()"></button>
        </div>
        <div class="modal-body">
          <div class="d-block wide pt-4">
            <!-- Phone Display -->
            <button type="button" class="btn btn-block btn-outline-default wide mt-3" *ngFor="let rp of falsePositiveTypes" 
              (click)="notAFire(incident, rp.falsePositiveTypeId);falsePositiveModal.hide()">{{rp.displayName}}</button>
          </div>
        </div>
        <div class="modal-footer">
          <button (click)="falsePositiveModal.hide()" class="btn btn-white">Cancel</button>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-2">
    <ng-container *ngIf="status && fire.incidentsByStatus && fire.incidentsByStatus[status.statusId] && fire.incidentsByStatus[status.statusId].length > 0; else noIncidents"> 
      <div class="col-sm-12" [ngClass]="{'col-lg-4 col-md-6':fire.incidentsByStatus[status.statusId].length >= 4,'col-lg-6 col-md-12':fire.incidentsByStatus[status.statusId].length >= 2 && fire.incidentsByStatus[status.statusId].length < 4, 'col-12': fire.incidentsByStatus[status.statusId].length == 0}" *ngFor="let incident of fire.incidentsByStatus[status.statusId]">
        <div class="card mb-4 bg-emphasis bg-opacity-25">
          <div class="card-header  d-flex">

              <span class="flex-grow-1"> 
                <span class="small text-inverse text-opacity-50 mr-2">#{{incident.incidentId}}</span>
                <span class=""> {{incident.site.name}}</span>
                <br/>
                <div class="small text-inverse text-opacity-50">{{incident.fireIncidentDate | relativeDate}}</div>
              </span>
              

              <a title="Not a Fire" (click)="notAFire(incident, null)" class="mr-4 btn btn-outline-default text-inverse text-opacity-50 text-decoration-none cursor">
                <i class="fa fa-2x fa-times-circle"></i>
              </a>

              <a title="Open Incident" [routerLink]="['/fire-foresight/incident/', incident.incidentId]" class="btn btn-outline btn-outline-default text-inverse text-opacity-50 text-decoration-none cursor">
                <i class="fa fa-2x fa-arrow-up-right-from-square"></i>
              </a>
          </div>
          <div class="card-body p-0" *ngIf="incident.status.statusId == statusId; else wrongStatus">
            <!--<smart-image [showMetaData]="true" [src]="incident.firstImageUrl" ></smart-image>-->
            <smart-image-list #incidentImage *ngIf="!dayMode" [showZones]="showZones" [zones]="zones" [showLineAt]="showLineAt" [showMetaData]="true" [images]="fire.detectionImages[incident.incidentId]" ></smart-image-list>
          </div>
          <ng-template #wrongStatus>
            <div class="ratio ratio-16x9">
              <div class="d-flex justify-content-center align-items-center h-100">
                <div class="text-center">
                  <div class="h5">Incident status has changed to "{{incident.status.displayName}}"</div>
                  <div>Please refresh the page to see the latest incidents.</div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </ng-container>
    <ng-template #noIncidents>
      <div class="col-12">
        <div class="alert alert-info">
          No incidents found for this status.
        </div>
      </div>
    </ng-template>
  </div>
</div>

</div>